import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { MdbScrollspyModule } from 'mdb-angular-ui-kit/scrollspy';
import { MdbDropdownModule } from 'mdb-angular-ui-kit/dropdown';
import { AppraisalDataService } from '../../shared/services/appraisal-data.service';
import { Appraisal, ApprovalState, ApprovalStatus, GroupFieldConfig, GroupItem, TransformationResult, ValuationScenario } from '../../models/appraisal';
import { UserService } from '../../shared/services/user.service';
import { HttpClient } from '@angular/common/http';
import { SaveModalPopupComponent } from '../save-modal-popup/save-modal-popup.component';
import { ValidatorsMap } from '../../shared/validation-config';
import { environment } from '../../../environments/environment';
import { AgGridModule } from 'ag-grid-angular';
import { LookupService } from '../../shared/services/lookup.service';
import { forkJoin } from 'rxjs';
import { PriorDeltaFieldComponent } from '../prior-delta-field/prior-delta-field.component';
import { SectionService } from '../../shared/services/section.service';
@Component({
  selector: 'app-appraisal-item',
  standalone: true,
  providers: [DatePipe],
  imports: [CommonModule, MatTabsModule, MdbFormsModule, MdbTabsModule, MdbScrollspyModule,
    MdbDropdownModule, SaveModalPopupComponent, AgGridModule, PriorDeltaFieldComponent],
  templateUrl: './appraisal-item.component.html',
  styleUrl: './appraisal-item.component.scss'
})
export class AppraisalItemComponent {
  @Input() rowData: any = null; // Data passed as an input
  rowDetails: any = {}; // Holds parsed row data
  tabs: any[] = []; // Store field groups for tabs
  userData: any;
  editedRows: Appraisal[] = [];
  activityNumber!: string;
  lookupValues: { [key: string]: string[] } = {};
  dataLoaded: boolean = false;
  FIXED_VALUES_JSON: { [key: string]: any } = {
    'Property Third Party Report Company Name': 'Cushman & Wakefield',
    'Property Valuation Member Institute Indicator': 'Yes',
    'Property Third Party Report Scope Standard Type': 'USPAP',
    'Property Valuation Is Concluded Indicator': 'Yes',
    'Property Land Ownership Right Type': 'Fee Simple',
    'Property Valuation MAH Opinion Type': 'Unrestricted Value',
    'Property Smoke Alarm Indicator': 'Yes',
    'Property Third Party Report Type': 'APPR',
    'Property Electric Responsible Party Type': 'Owner',
    'Property Water Responsible Party Type': 'Owner',
    'Property Sewer Responsible Party Type': 'Owner',
    'Property Gas Responsible Party Type': 'Owner',
    'Property Refuse Responsible Party Type': 'Owner',
    'Property Valuation Comment': 'N/A',
    'Property Valuation Project Amenity Description': 'String'
  };
  valuationScenarios: any[] = [];
  valuationScenarioDefs: { index: number; field: string; headerName: string }[] = [];
  valuationSections: { id: string; title: string | null; rows: any[]; }[] = [];
  @ViewChild('approvalModal') approvalModal!: SaveModalPopupComponent;
  constructor(private router: Router, private route: ActivatedRoute, private datePipe: DatePipe, private appraisalDataService: AppraisalDataService,
    private userService: UserService, private http: HttpClient, private lookupService: LookupService, private sectionService: SectionService) { }
    
  ngOnInit(): void {
    this.sectionService.setSelectedSubSection('Subject Property');
    // this.rowDetails = this.appraisalDataService.getRowData();

    this.activityNumber = this.route.snapshot.paramMap.get('id')!;
    this.userService.userData$.subscribe((data) => {
      if (data !== null) {
        this.userData = data;
        setTimeout(() => forkJoin({
          country: this.lookupService.getAllowedValues('CountryName'),
          city: this.lookupService.getAllowedValues('CityName'),
          state: this.lookupService.getAllowedValues('StateName'),
          zipCode: this.lookupService.getAllowedValues('ZipCode'),
          propertyType: this.lookupService.getAllowedValues('PropertyType'),
          areaMeasure: this.lookupService.getAllowedValues('AreaMeasureName'),
          hvacType: this.lookupService.getAllowedValues('HVACType'),
          utilityPaidBy: this.lookupService.getAllowedValues('UtilityPaidBy'),
          landOwnershipInterest: this.lookupService.getAllowedValues('LandOwnershipInterest')
          // Add additional lookup observables as needed.
        }).subscribe((result: any) => {
          // Store the lookup values in an object using keys that match your ValidatorsMap keys.
          this.lookupValues = {
            CountryName: result.country,
            CityName: result.city,
            StateName: result.state,
            ZipCode: result.zipCode,
            PropertyType: result.propertyType,
            AreaMeasureName: result.areaMeasure,
            HVACType: result.hvacType,
            UtilityPaidBy: result.utilityPaidBy,
            LandOwnershipInterest: result.landOwnershipInterest
          };
          this.fetchData(this.activityNumber);
        }));
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateSectionErrors();
      // this.scrollToFirstErrorSection();
    }, 0);
  }

  defaultColDef = {
    resizable: true,
    sortable: true,
    suppressMovable: true,
    cellClass: 'readonly-cell',
    wrapText: true,
    autoHeight: true
  };
  
  canonicalHeader: Record<string, string> = {
      asis: 'As Is',
      ascompleted: 'As Completed',
      asstabilized: 'As Stabilized',
      uponcompletion: 'Upon Completion',
      uponstabilization: 'Upon Stabilization'
    };

  fetchData(activityNumber: string): void {
    const norm = (v: any) =>
      (v ?? '').toString().trim().toLowerCase().replace(/[^a-z0-9]/g, '');
    const apiUrl = environment.appraisalApiConfig.baseUrl + '/' + activityNumber; // API endpoint
    this.http.get<TransformationResult<any>>(apiUrl).subscribe(
      (result) => {
        // if (!result.isValid) {
        //   console.error('Validation errors while fetching data:', result.validationErrors);
        //   alert('Failed to fetch data:\n' + result.validationErrors.map(err => err.message).join('\n'));
        //   return;
        // }
        this.rowDetails = result.value;
        this.appraisalDataService.setRowData(this.rowDetails);
        this.valuationScenarios = (this.rowDetails?.valuationSummary?.scenarios || [])
          .filter((s: any) => !s.IncludeScenario || s.IncludeScenario === 'Yes');

        this.valuationScenarioDefs = this.valuationScenarios.map((s: any, idx: number) => ({
          index: idx,
          field: `scenario_${idx}`,
          headerName: s.valueCondition != '' && this.canonicalHeader[norm(s.valueCondition)] != '' ? this.canonicalHeader[norm(s.valueCondition)] : '' // column header
        }));

        this.buildValuationSections();
        let rows = this.pivotedValuationSummary;
        setTimeout(() => {
          this.calculateSectionErrors();
        });

      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  approveSelected(): void {
    this.approvalModal.open('Approve');
  }

  rejectSelected(): void {
    this.approvalModal.open('Reject');
  }

  approveSelectedWithComments(comments: string): void {
    const selectedNodes = [this.rowDetails];
    if (selectedNodes.length === 0) {
      alert('Please select at least one row.');
      return;
    }

    selectedNodes.forEach((node: any) => {
      let appraisal: Appraisal = this.mapToAppraisal(node);
      let latestReview = appraisal.LatestReview || {} as ApprovalStatus;

      if (!latestReview) {
        alert('No review history found for this record.');
        return;
      }

      // Prevent re-approval of already approved/rejected records
      // if (latestReview.Status === ApprovalState.Approved || latestReview.Status === ApprovalState.Rejected) {
      //   alert(`Record ${appraisal.ActivityNumber} has already been ${latestReview.Status === ApprovalState.Approved
      //     ? 'Approved' : 'Rejected'} and cannot be changed.`);
      //   return;
      // }

      if (this.userData.roles.includes('Appraiser')) {
        this.updateApprovalStatus(appraisal, ApprovalState.PendingPortfolioReview, comments ?? 'Appraiser approved.');
      } else if (this.userData.roles.includes('PortfolioCoordinator')) {
        this.updateApprovalStatus(appraisal, ApprovalState.Approved, comments ?? 'Portfolio Coordinator approved.');
      } else if (this.userData.roles.includes('QualityControl')) {
        this.updateApprovalStatus(appraisal, ApprovalState.Approved, comments ?? 'Quality Control approved.');
      } else if (this.userData.roles.includes('GlobalAdmin')) {
        this.updateApprovalStatus(appraisal, ApprovalState.Approved, comments ?? 'Admin approved.');
      }
    });

    this.saveAllChanges();
  }

  rejectSelectedWithComments(comments: string): void {
    const selectedNodes = [this.rowDetails];
    if (selectedNodes.length === 0) {
      alert('Please select at least one row.');
      return;
    }

    selectedNodes.forEach((node: any) => {
      let appraisal: Appraisal = this.mapToAppraisal(node);
      let latestReview = appraisal.LatestReview || {} as ApprovalStatus;

      if (!latestReview) {
        alert('No review history found for this record.');
        return;
      }

      // Prevent re-approval of already approved/rejected records
      // if (latestReview.Status === ApprovalState.Approved || latestReview.Status === ApprovalState.Rejected) {
      //   alert(`Record ${appraisal.ActivityNumber} has already been ${latestReview.Status === ApprovalState.Approved
      //     ? 'Approved' : 'Rejected'} and cannot be changed.`);
      //   return;
      // }

      if (this.userData.roles.includes('PortfolioCoordinator')) {
        this.updateApprovalStatus(appraisal, ApprovalState.Rejected, comments ?? 'Portfolio Coordinator rejected.');
      } else if (this.userData.roles.includes('QualityControl')) {
        this.updateApprovalStatus(appraisal, ApprovalState.Rejected, comments ?? 'Quality Control rejected.');
      } else if (this.userData.roles.includes('GlobalAdmin')) {
        this.updateApprovalStatus(appraisal, ApprovalState.Rejected, comments ?? 'Admin rejected.');
      }
    });

    this.saveAllChanges();
  }

  updateApprovalStatus(appraisal: Appraisal, newStatus: ApprovalState, comments: string) {
    let updatedReview: ApprovalStatus = {
      Id: crypto.randomUUID(),
      AppraisalId: appraisal.ActivityNumber,
      UserInfo: {
        email: this.userData.email,
        displayName: this.userData.displayName,
        name: this.userData.displayName,
        id: this.userData.userId,
        groups: [],
        roles: this.userData.roles,
        currentRole: this.userData.currentRole
      },
      Status: newStatus,
      Comments: comments,
      ActionDate: new Date().toISOString(),
      EntityType: 'ApprovalStatus'
    };

    // Update LatestReview
    appraisal.LatestReview = updatedReview;

    // Append to ReviewHistory
    appraisal.ReviewHistory.push(updatedReview);

    // Add to edited rows
    this.editedRows.push(appraisal);
  }

  saveAllChanges(): void {
    if (this.editedRows.length > 0) {
      this.http.put<TransformationResult<any>>(environment.appraisalApiConfig.baseUrl, this.editedRows).subscribe(
        (result) => {
          // if (!result.isValid) {
          //   console.error('Validation errors while saving changes:', result.validationErrors);
          //   alert('Failed to save changes:\n' + result.validationErrors.map(err => err.message).join('\n'));
          //   return;
          // }
          // console.log('All changes saved successfully:', result.value);
          this.editedRows = []; // Clear the temporary array
          alert('Changes saved successfully!');
          this.router.navigate(['/vault']);
        },
        (error) => {
          console.error('Error saving changes:', error);
          alert('Failed to save changes. Please try again.');
        }
      );
    } else {
      // console.log('No changes to save.');
      alert('No changes to save.');
    }
  }

  mapToAppraisal(apiData: any): Appraisal {
    return {
      ActivityNumber: apiData.activityNumber,
      ExternalReferenceId: apiData.externalReferenceId || '',
      TimeStamp: apiData.timeStamp,
      Rowkey: apiData.rowkey,
      HasJobCenterInfo: apiData.hasJobCenterInfo,
      JobCenterActivity: apiData.jobCenterActivity,
      FileName: apiData.fileName,
      Project: apiData.project
        ? {
          projectId: apiData.project.projectId || '',
          projectName: apiData.project.projectName || '',
          projectNumber: apiData.project.projectNumber || '',
          portfolio: apiData.project.portfolio || {}
        }
        : undefined,
      PropertyTypeAndTenancy: {
        PropertyType: apiData.propertyTypeAndTenancy?.propertyType || '',
        PropertySubtype: apiData.propertyTypeAndTenancy?.propertySubtype || '',
        Tenancy: apiData.propertyTypeAndTenancy?.tenancy || ''
      },
      SubjectPropertyLocation: {
        PropertyId: apiData.subjectPropertyLocation?.propertyId || '',
        PropertyName: apiData.subjectPropertyLocation?.propertyName || '',
        AddressLine1: apiData.subjectPropertyLocation?.addressLine1 || '',
        City: apiData.subjectPropertyLocation?.city || '',
        County: apiData.subjectPropertyLocation?.county || '',
        State: apiData.subjectPropertyLocation?.state || '',
        ZipCode: apiData.subjectPropertyLocation?.zipCode || '',
        Country: apiData.subjectPropertyLocation?.country || '',
        Region: apiData.subjectPropertyLocation?.region || '',
        MetropolitanStatisticalArea:
          apiData.subjectPropertyLocation?.metropolitanStatisticalArea || '',
        Market: apiData.subjectPropertyLocation?.market || '',
        Submarket: apiData.subjectPropertyLocation?.submarket || '',
        StreetLocation: apiData.subjectPropertyLocation?.streetLocation || '',
        Latitude: apiData.subjectPropertyLocation?.latitude || '',
        Longitude: apiData.subjectPropertyLocation?.longitude || ''
      },
      ParcelInformation: {
        AssessorsParcelNumber:
          apiData.parcelInformation?.assessorsParcelNumber || ''
      },
      SiteInformation: {
        Shape: apiData.siteInformation?.shape || '',
        Topography: apiData.siteInformation?.topography || '',
        Access: apiData.siteInformation?.access || '',
        Visibility: apiData.siteInformation?.visibility || '',
        Frontage: apiData.siteInformation?.frontage || '',
        SiteImprovements: apiData.siteInformation?.siteImprovements || '',
        PrimaryLandMeasure: apiData.siteInformation?.primaryLandMeasure || '',
        PrimaryLandValue: apiData.siteInformation?.primaryLandValue || '',
        PrimaryLandExcess: apiData.siteInformation?.primaryLandExcess || '',
        PrimaryLandUnit: apiData.siteInformation?.primaryLandUnit || '',
        SecondaryLandMeasure: apiData.siteInformation?.secondaryLandMeasure || '',
        SecondaryLandValue: apiData.siteInformation?.secondaryLandValue || '',
        SecondaryLandExcess: apiData.siteInformation?.secondaryLandExcess || '',
        SecondaryLandUnit: apiData.siteInformation?.secondaryLandUnit || '',
        GroundLeases: apiData.siteInformation?.groundLeases || '',
        GroundLeaseDescription: apiData.siteInformation?.groundLeaseDescription || '',

        Electic: apiData.siteInformation?.electric || '',
        Gas: apiData.siteInformation?.gas || '',
        Refuse: apiData.siteInformation?.refuse || '',
        Sewer: apiData.siteInformation?.sewer || '',
        Water: apiData.siteInformation?.water || '',
        Telephone: apiData.siteInformation?.telephone || ''
      },
      Ownership: apiData.ownership
        ? {
          PropertyOwnershipEntity: apiData.ownership?.propertyOwnershipEntity,
          SoldInLastThreeYears: apiData.ownership?.soldInLastThreeYears,
          SaleDate: apiData.ownership?.saleDate,
          SalePrice: apiData.ownership?.salePrice,
          ListPrice: apiData.ownership?.listPrice,
          ContractPrice: apiData.ownership?.contractPrice
        }
        : undefined,
      SiteConditions: apiData.siteConditions
        ? {
          SoilConditions: apiData.siteConditions?.soilConditions || '',
          LandUseRestrictions:
            apiData.siteConditions?.landUseRestrictions || '',
          Wetlands: apiData.siteConditions?.wetlands || '',
          HazardousSubstances:
            apiData.siteConditions?.hazardousSubstances || '',
          OverallUtility: apiData.siteConditions?.overallUtility || '',
          Summary: apiData.siteConditions?.summary || ''
        }
        : undefined,
      FloodZoneInformation: {
        FloodMapNumber:
          apiData.floodZoneInformation?.floodMapNumber || '',
        FloodMapDate: apiData.floodZoneInformation?.floodMapDate || '',
        FloodZone: apiData.floodZoneInformation?.floodZone || '',
        FloodZoneComment:
          apiData.floodZoneInformation?.floodZoneComment || ''
      },
      ImprovementInformation: {
        PrimaryImprovementMeasure:
          apiData.improvementInformation?.primaryImprovementMeasure || '',
        PrimaryImprovementValue:
          apiData.improvementInformation?.primaryImprovementValue || '',
        PrimaryImprovementPriorValue:
          apiData.improvementInformation?.primaryImprovementPriorValue || '',
        PrimaryImprovementUnit:
          apiData.improvementInformation?.primaryImprovementUnit || '',
        SecondaryImprovementMeasure:
          apiData.improvementInformation?.secondaryImprovementMeasure || '',
        SecondaryImprovementValue:
          apiData.improvementInformation?.secondaryImprovementValue || '',
        SecondaryImprovementPriorValue:
          apiData.improvementInformation?.secondaryImprovementPriorValue || '',
        SecondaryImprovementUnit:
          apiData.improvementInformation?.secondaryImprovementUnit || '',
        TertiaryImprovementMeasure:
          apiData.improvementInformation?.tertiaryImprovementMeasure || '',
        TertiaryImprovementValue:
          apiData.improvementInformation?.tertiaryImprovementValue || '',
        TertiaryImprovementPriorValue:
          apiData.improvementInformation?.tertiaryImprovementPriorValue || '',
        TertiaryImprovementUnit:
          apiData.improvementInformation?.tertiaryImprovementUnit || '',
        YearBuilt: apiData.improvementInformation?.yearBuilt || '',
        YearRenovated: apiData.improvementInformation?.yearRenovated || '',
        EffectiveAge: apiData.improvementInformation?.effectiveAge || '',
        EconomicLife:
          apiData.improvementInformation?.economicLife || '',
        NumberOfStories:
          apiData.improvementInformation?.numberOfStories || '',
        NumberOfBuildings:
          apiData.improvementInformation?.numberOfBuildings || '',
        PropertyClass:
          apiData.improvementInformation?.propertyClass || '',
        BuildingCondition:
          apiData.improvementInformation?.buildingCondition || '',
        BuildingQuality:
          apiData.improvementInformation?.buildingQuality || '',        
        Occupancy: apiData.improvementInformation?.occupancy || '',
        PriorOccupancy:
          apiData.improvementInformation?.priorOccupancy || '',
        Vacancy: apiData.improvementInformation?.vacancy || '',
        PriorVacancy:
          apiData.improvementInformation?.priorVacancy || ''        
      },
      ImprovementInformationIndustrial: {
        PercentOfficeSpace:
          apiData.improvementInformationIndustrial?.percentOfficeSpace || '',
        ClearCeilingHeight:
          apiData.improvementInformationIndustrial?.clearCeilingHeight || '',
        NumberOfDockHighDoors:
          apiData.improvementInformationIndustrial?.numberOfDockHighDoors || '',
        NumberOfDriveInDoors:
          apiData.improvementInformationIndustrial?.numberOfDriveInDoors || ''
      },
      ImprovementInformationLiving: {
        NumberOfUnits:
          apiData.improvementInformationLiving?.numberOfUnits || '',
        ProjectAmenities:
          apiData.improvementInformationLiving?.projectAmenities || '',
        UnitAmenities:
          apiData.improvementInformationLiving?.unitAmenities || ''
      },
      ImprovementInformationRetail: {
        NumberOfAnchors:
          apiData.improvementInformationRetail?.numberOfAnchors || '',
        TotalAnchorsArea:
          apiData.improvementInformationRetail?.totalAnchorsArea || '',
        TotalAnchorsGrossLeasableAreaPercentage:
          apiData.improvementInformationRetail?.totalAnchorsGrossLeasableAreaPercentage || ''
      },
      TenantInformation: {
        LargestTenant: apiData.tenantInformation?.largestTenant || '',
        LargestTenantArea: apiData.tenantInformation?.largestTenantArea || '',
        AvgExpiries: apiData.tenantInformation?.avgExpiries || '',
        LeaseExpires: apiData.tenantInformation?.leaseExpires || '',
        NumberOfTenants: apiData.tenantInformation?.noOfTenants || '',
      },
      ConstructionDetails: {
        BasicConstruction:
          apiData.constructionDetails?.basicConstruction || '',
        ConstructionStatus:
          apiData.constructionDetails?.constructionStatus || '',
        ExteriorWalls:
          apiData.constructionDetails?.exteriorWalls || '',
        RoofType: apiData.constructionDetails?.roofType || '',
        RoofSurface: apiData.constructionDetails?.roofSurface || ''        
      },
      MechanicalDetails: {
        HVAC: apiData.mechanicalDetails?.hvac || '',
        FireProtection:
          apiData.mechanicalDetails?.fireProtection || '',
        Security: apiData.mechanicalDetails?.security || '',
        NumberofPassengerElevators: apiData.mechanicalDetails?.numberofPassengerElevators || '',
        NumberofFreightElevators: apiData.mechanicalDetails?.numberofFreightElevators || ''
      },
      Parking: apiData.parking
        ? {
          ParkingTypeOne:
            apiData.parking?.parkingTypeOne || '',
          ParkingTypeOneNoOfSpaces:
            apiData.parking?.parkingTypeOneNoOfSpaces || '',
          ParkingTypeTwo:
            apiData.parking?.parkingTypeTwo || '',
          ParkingTypeTwoNoOfSpaces:
            apiData.parking?.parkingTypeTwoNoOfSpaces || '',
          ParkingTypeThree:
            apiData.parking?.parkingTypeThree || '',
          ParkingTypeThreeNoOfSpaces:
            apiData.parking?.parkingTypeThreeNoOfSpaces || ''
        }
        : undefined,
      Taxes: {
        CurrentTaxYear: apiData.taxes?.currentTaxYear || '',
        AssessmentRatio: apiData.taxes?.assessmentRatio || '',
        EqualizationRate: apiData.taxes?.equalizationRate || '',
        AreTaxesCurrent: apiData.taxes?.areTaxesCurrent || '',
        IsThereAGrievanceUnderway:
          apiData.taxes?.isThereAGrievanceUnderway || '',
        TheSubjectsAssessmentAndTaxesAre:
          apiData.taxes?.theSubjectsAssessmentAndTaxesAre || '',
        TotalTaxRate: apiData.taxes?.totalTaxRate || '',
        TotalPropertyTaxes: apiData.taxes?.totalPropertyTaxes || '',
        MonthTaxesDueWithoutPenalty:
          apiData.taxes?.monthTaxesDueWithoutPenalty || '',
        PercentDiscountIfTaxBillPaidByDecember:
          apiData.taxes?.percentDiscountIfTaxBillPaidByDecember || '',
        TotalTaxExemptions: apiData.taxes?.totalTaxExemptions || '',
        TotalAssessedValue: apiData.taxes?.totalAssessedValue || '',
        ImprovementsAssessedValue: apiData.taxes?.improvementsAssessedValue || '',
        LandAssessedValue:  apiData.taxes?.landAssessedValue || '',
        AssessorsMarketValue: apiData.taxes?.assessorsMarketValue || ''
      },
      Zoning: apiData.zoning
        ? {
          CurrentZoning: apiData.zoning?.currentZoning || '',
          IsCurrentUsePermitted:
            apiData.zoning?.isCurrentUsePermitted || '',
          PermittedUses: apiData.zoning?.permittedUses || '',
          ProhibitedUses: apiData.zoning?.prohibitedUses || ''
        }
        : undefined,
      ConstructionCosts: apiData.constructionCosts 
        ? {
          SoftCosts:
          apiData.constructionDetails?.softCosts || '',
        FurnitureFixturesandEquipment:
          apiData.constructionDetails?.furnitureFixturesandEquipment || '',
        SiteImprovementCost:
          apiData.constructionDetails?.siteImprovementCost || '',
        BuildingImprovementCosts:
          apiData.constructionDetails?.buildingImprovementCosts || '',
        TotalEntrepreneurialProfit:
          apiData.constructionDetails?.totalEntrepreneurialProfit || ''
        }
          : undefined,
      Valuations: apiData.valuations
        ? {
          Currency: apiData.valuations?.currency || '',
          DateOfReport: apiData.valuations?.dateOfReport || '',
          DateOfInspection: apiData.valuations?.dateOfInspection || '',
          FIRREA: apiData.valuations?.firrea || '',
          IsUSPAPCompliant:
            apiData.valuations?.isUSPAPCompliant || '',
          Stabilized: apiData.valuations?.stabilized || '',
          ClientOwnership:
            apiData.valuations?.clientOwnership || '',
          PreviouslyAppraised:
            apiData.valuations?.previouslyAppraised || '',
          Partner:
            apiData.valuations?.partner || ''
        }
        : undefined,
      CashFlowModel: apiData.cashFlowModel
        ? {
          CashFlowModelName:
            apiData.cashFlowModel?.cashFlowModelName || '',
          PortfolioName:
            apiData.cashFlowModel?.portfolioName || '',
          ScenarioName:
            apiData.cashFlowModel?.scenarioName || '',
          PropertyName:
            apiData.cashFlowModel?.propertyName || ''
        }
        : undefined,
      Cashflow: {
        NetOperatingIncomeTotal: {
          Year1: apiData.cashflow?.netOperatingIncome?.year1 || '',
          Year2: apiData.cashflow?.netOperatingIncome?.year2 || '',
          Year3: apiData.cashflow?.netOperatingIncome?.year3 || '',
          Year4: apiData.cashflow?.netOperatingIncome?.year4 || '',
          Year5: apiData.cashflow?.netOperatingIncome?.year5 || '',
          Year6: apiData.cashflow?.netOperatingIncome?.year6 || '',
          Year7: apiData.cashflow?.netOperatingIncome?.year7 || '',
          Year8: apiData.cashflow?.netOperatingIncome?.year8 || '',
          Year9: apiData.cashflow?.netOperatingIncome?.year9 || '',
          Year10: apiData.cashflow?.netOperatingIncome?.year10 || '',
          Year11: apiData.cashflow?.netOperatingIncome?.year11 || ''
        },
        ImpliedOverallRate: {
          Year1: apiData.cashflow?.impliedOverallRate?.year1 || '',
          Year2: apiData.cashflow?.impliedOverallRate?.year2 || '',
          Year3: apiData.cashflow?.impliedOverallRate?.year3 || '',
          Year4: apiData.cashflow?.impliedOverallRate?.year4 || '',
          Year5: apiData.cashflow?.impliedOverallRate?.year5 || '',
          Year6: apiData.cashflow?.impliedOverallRate?.year6 || '',
          Year7: apiData.cashflow?.impliedOverallRate?.year7 || '',
          Year8: apiData.cashflow?.impliedOverallRate?.year8 || '',
          Year9: apiData.cashflow?.impliedOverallRate?.year9 || '',
          Year10: apiData.cashflow?.impliedOverallRate?.year10 || '',
          Year11: apiData.cashflow?.impliedOverallRate?.year11 || ''
        },
        Year1NOIPSF: apiData.cashflow?.year1NOIPSF || '',
        Walt: apiData.cashflow?.walt || '',
        PriorWalt: apiData.cashflow?.priorWalt || '',
        Downtime: apiData.cashflow?.downtime || '',
        Concessions: apiData.cashflow?.concessions || '',
        PriorConcessions: apiData.cashflow?.priorConcessions || '',
        CollectionLoss: apiData.cashflow?.collectionLoss || '',
        PriorCollectionLoss: apiData.cashflow?.priorCollectionLoss || '',
        RealEstateTaxGrowthRate: apiData.cashflow?.realEstateTaxGrowthRate || '',        
        NetCashFlowAmount: apiData.cashflow?.netCashFlowAmount || ''
      },
      CashflowLiving: apiData.cashflowLiving
        ? {
          NonApartmentTotalPSF:
            apiData.cashflowLiving?.nonApartmentTotalPSF || ''
        }
        : undefined,
      CashflowRetail: apiData.cashflowRetail
        ? {
          RollingTwelveMonthsSalesPSF:
            apiData.cashflowRetail?.rollingTwelveMonthsSalesPSF || ''
        }
        : undefined,
      Assumptions: apiData.modelAssumptions
        ? {
          MarketInflationYears1_5:
            apiData.modelAssumptions?.marketInflationYears1_5 || '',
          PriorMarketInflationYears1_5:
            apiData.modelAssumptions?.priorMarketInflationYears1_5 || '',
          ExpenseInflationYears1_5:
            apiData.modelAssumptions?.expenseInflationYears1_5 || '',
          PriorExpenseInflationYears1_5:
            apiData.modelAssumptions?.priorExpenseInflationYears1_5 || ''
        }
        : undefined,
      LeaseExpirations: apiData.leaseExpirations
        ? {
          FiveYearCumulativeExpirationsPSF:
            apiData.leaseExpirations?.fiveYearCumulativeExpirationsPSF ||
            ''
        }
        : undefined,
      LeasingAssumptions: {
        LeaseType:
          apiData.leasingAssumptions?.leaseType || '',
        MarketLeaseTerm:
          apiData.leasingAssumptions?.marketLeaseTerm || '',
        RenewalProbability:
          apiData.leasingAssumptions?.renewalProbability || '',
        MarketLeasingTenantImprovementsNewLeases:
          apiData.leasingAssumptions?.marketLeasingTenantImprovementsNewLeases || '',
        MarketLeasingCommissionsNewLeases:
          apiData.leasingAssumptions?.marketLeasingCommissionsNewLeases || '',
        Year1TenantImprovements:
          apiData.leasingAssumptions?.year1TenantImprovements || '',
        Year1LeasingCommissions:
          apiData.leasingAssumptions?.year1LeasingCommissions || '',
        FreeRent:
          apiData.leasingAssumptions?.freeRent || '',
        ExpenseReimbursement: apiData.leasingAssumptions?.expenseReimbursement || '',
      },
      ContractMonthRent: {
        AverageContractRentPSF:
          apiData.contractMonthRent?.averageContractRentPSF || '',
        PriorAverageContractRentPSF:
          apiData.contractMonthRent?.priorAverageContractRentPSF || '',
        AnnualContractRentTotal:
          apiData.contractMonthRent?.annualContractRentTotal || '',
        PriorAnnualContractRentTotal:
          apiData.contractMonthRent?.priorAnnualContractRentTotal || '',
        AverageMarketRentPSF:
          apiData.contractMonthRent?.averageMarketRentPSF || '',
        PriorAverageMarketRentPSF:
          apiData.contractMonthRent?.priorAverageMarketRentPSF || '',
        AnnualMarketRentTotal:
          apiData.contractMonthRent?.annualMarketRentTotal || '',
        CWProjectionMonthlyMarketRent:
          apiData.contractMonthRent?.cwProjectionMonthlyMarketRent || '',
        CRMR: apiData.contractMonthRent?.crmr || '',
        MarketOccupancyPercent: apiData.contractMonthRent?.MarketOccupancyPercent || ''
      },
      ValuationSummary: apiData.valuationSummary,
      RevenueAndExpense: apiData.revenueAndExpense
        ? {
          YearOne: {
            BaseRentalRevenue: apiData.revenueAndExpense?.yearOne?.baseRentalRevenue || '',
            TotalOtherIncome: apiData.revenueAndExpense?.yearOne?.totalOtherIncome || '',
            PotentialGrossRevenue: apiData.revenueAndExpense?.yearOne?.potentialGrossRevenue || '',
            VacancyandCollectionLoss: apiData.revenueAndExpense?.yearOne?.vacancyandCollectionLoss || '',
            EffectiveGrossRevenue: apiData.revenueAndExpense?.yearOne?.effectiveGrossRevenue || '',
            GroundRent: apiData.revenueAndExpense?.yearOne?.groundRent || '',
            TotalExpenses: apiData.revenueAndExpense?.yearOne?.totalExpenses || '',
            NOITotalAmount: apiData.revenueAndExpense?.yearOne?.noiTotalAmount || '',
            OperatingExpenses: apiData.revenueAndExpense?.yearOne?.operatingExpenses || '',
            GeneralnAdministrative: apiData.revenueAndExpense?.yearOne?.generalnAdministrative || '',
            Insurance: apiData.revenueAndExpense?.yearOne?.insurance || '',
            ManagementFees: apiData.revenueAndExpense?.yearOne?.managementFees || '',
            RealEstateTaxes: apiData.revenueAndExpense?.yearOne?.realEstateTaxes || '',
            ReplacementReserves: apiData.revenueAndExpense?.yearOne?.replacementReserves || ''
          },
          StabilizedYear: {
            BaseRentalRevenue: apiData.revenueAndExpense?.stabilizedYear?.baseRentalRevenue || '',
            TotalOtherIncome: apiData.revenueAndExpense?.stabilizedYear?.totalOtherIncome || '',
            PotentialGrossRevenue: apiData.revenueAndExpense?.stabilizedYear?.potentialGrossRevenue || '',
            VacancyandCollectionLoss: apiData.revenueAndExpense?.stabilizedYear?.vacancyandCollectionLoss || '',
            EffectiveGrossRevenue: apiData.revenueAndExpense?.stabilizedYear?.effectiveGrossRevenue || '',
            GroundRent: apiData.revenueAndExpense?.stabilizedYear?.groundRent || '',
            TotalExpenses: apiData.revenueAndExpense?.stabilizedYear?.totalExpenses || '',
            NOITotalAmount: apiData.revenueAndExpense?.stabilizedYear?.noiTotalAmount || '',
            OperatingExpenses: apiData.revenueAndExpense?.stabilizedYear?.operatingExpenses || '',
            GeneralnAdministrative: apiData.revenueAndExpense?.stabilizedYear?.generalnAdministrative || '',
            Insurance: apiData.revenueAndExpense?.stabilizedYear?.insurance || '',
            ManagementFees: apiData.revenueAndExpense?.stabilizedYear?.managementFees || '',
            RealEstateTaxes: apiData.revenueAndExpense?.stabilizedYear?.realEstateTaxes || '',
            ReplacementReserves: apiData.revenueAndExpense?.stabilizedYear?.replacementReserves || ''
          }
        }
        : undefined,
      ValuationComments: apiData.valuationComments
        ? {
          AppraisalValueComments:
            apiData.valuationComments?.appraisalValueComments || ''
        }
        : undefined,
      ReviewHistory:
        apiData.reviewHistory?.map((review: any) => ({
          Id: review?.id || '',
          AppraisalId: review?.appraisalId || '',
          UserInfo: review?.userInfo || {},
          Status: review?.status || 0,
          Comments: review?.comments || '',
          ActionDate: review?.actionDate || '',
          EntityType: review?.entityType || ''
        })) || [],
      LatestReview: apiData.latestReview
        ? {
          Id: apiData.latestReview?.id || '',
          AppraisalId: apiData.latestReview?.appraisalId || '',
          UserInfo: apiData.latestReview?.userInfo || {},
          Status: apiData.latestReview?.status || 0,
          Comments: apiData.latestReview?.comments || '',
          ActionDate: apiData.latestReview?.actionDate || '',
          EntityType: apiData.latestReview?.entityType || ''
        }
        : undefined,
      SubmittedBy: apiData.submittedBy || '',
      ComparableIds: apiData.comparableIds || []
    };
  }

  toTitleCase(value: string | null | undefined): string {
    if (!value) return '';
    return value
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  handleModalAction(event: { action: string, comments: string }) {
    if (event.action === 'Approve') {
      this.performApproval(event.comments);
    } else if (event.action === 'Reject') {
      this.performRejection(event.comments);
    }
  }

  performApproval(comments: string) {
    // console.log('Approving with comments:', comments);
    this.approveSelectedWithComments(comments);
  }

  performRejection(comments: string) {
    // console.log('Rejecting with comments:', comments);
    this.rejectSelectedWithComments(comments);
  }

  getValidationStatus(fieldPath: string, data: any): { valid: boolean; message?: string } {
    const validator = ValidatorsMap[fieldPath];
    if (!validator) return { valid: true };

    const value = this.resolveValidationValue(fieldPath, data);

    // Pass the lookup values (fetched earlier) to the validator.
    return validator(value, this.lookupValues);
  }

  private resolveValidationValue(fieldPath: string, data: any): any {
    // Deep access into data like rowDetails?.subjectPropertyLocation?.country
    const directValue = fieldPath.split('.').reduce((acc, key) => acc?.[key], data);
    if (directValue !== undefined) {
      return directValue;
    }
    
    if (fieldPath.includes('valuationSummary')) {
      const normalize = (value: any) =>
        String(value ?? '')
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]/g, '');

      const scenarioKey = fieldPath.split('.')?.[1];
      const metricPath = fieldPath.split('.').slice(2);
      const scenarios = data?.valuationSummary?.scenarios || [];

      const targetCanonical = (() => {
        switch (scenarioKey) {
          case 'asIsScenario':
            return 'asis';
          case 'uponCompletionScenario':
            return 'uponcompletion';
          case 'uponStabilizationScenario':
            return 'uponstabilization';
          default:
            return normalize(scenarioKey);
        }
      })();

      const scenario = scenarios.find((s: any) => {
        const scenarioName = normalize(s?.scenario);
        const valueCondition = normalize(s?.valueCondition);
        return scenarioName === targetCanonical || valueCondition === targetCanonical;
      });

      return scenario ? metricPath.reduce((acc, key) => acc?.[key], scenario) : undefined;
    }

    // Backward-compatible support for legacy RevenueAndExpense shape.
    if (fieldPath.startsWith('revenueAndExpense.')) {
      const [_, periodKey, fieldKey] = fieldPath.split('.');
      const legacyPath = [
        'RevenueAndExpense',
        this.toPascalCase(periodKey),
        this.toPascalCase(fieldKey)
      ];
      const legacyValue = legacyPath.reduce((acc, key) => acc?.[key], data);
      if (legacyValue !== undefined) {
        return legacyValue;
      }

      // Fallback to pre-migration valuation summary scenario structure.
      const legacyScenario = data?.valuationSummary?.scenarios?.[0];
      if (legacyScenario && fieldKey && legacyScenario[fieldKey] !== undefined) {
        return legacyScenario[fieldKey];
      }
    }

    return directValue;
  }

  private toPascalCase(value: string | undefined): string {
    if (!value) return '';
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  getLargestTenantAreaPercentage(rowDetails: any): string {
    if (rowDetails?.tenantInformation?.largestTenantArea == '')
      return '';

    const area = this.toNumber(rowDetails?.tenantInformation?.largestTenantArea?.toString().replace(/,/g, '')) || 0;
    const improvementStr = rowDetails?.improvementInformation?.primaryImprovementValue?.toString().replace(/,/g, '').trim();
    const improvementValue = this.toNumber(improvementStr) || 0;

    if (improvementValue === 0) return '';

    const percentage = (area / improvementValue) * 100;
    return percentage.toFixed(2) + '%';
  }


  isFormValid(): boolean {
    if (!this.dataLoaded || !this.rowDetails || Object.keys(this.rowDetails).length === 0) {
      return false;
    }

    for (const fieldPath in ValidatorsMap) {
      const validator = ValidatorsMap[fieldPath];
      const value = fieldPath.split('.').reduce((obj, key) => obj?.[key], this.rowDetails);
      const result = validator(value, this.lookupValues);
      if (!result.valid) {
        return false;
      }
    }

    return true;
  }

  sectionErrorCounts: { [sectionId: string]: number } = {};
  sectionList = [
    { id: 'Subject-Property', label: 'Subject Property' },
    { id: 'Location-Info', label: 'Location Information' },
    { id: 'Parcel-Info', label: 'Parcel Information' },
    { id: 'Site-Info', label: 'Site Information' },
    { id: 'Ownership', label: 'Ownership'},
    { id: 'Site-Conditions', label: 'Site Conditions' },
    { id: 'Flood-Zone', label: 'Flood Zone Information' },
    { id: 'Improvement-Info', label: 'Improvement Information' },
    { id: 'Improvement-Info-Industrial', label: 'Industrial Improvement' },
    { id: 'Improvement-Info-Living', label: 'Living Improvement' },
    { id: 'Improvement-Info-Retail', label: 'Retail Improvement' },
    { id: 'Construction-Details', label: 'Construction Details' },
    { id: 'Mechanical-Details', label: 'Mechanical Details' },
    { id: 'Parking', label: 'Parking' },
    { id: 'Taxes', label: 'Taxes' },
    { id: 'Zoning', label: 'Zoning' },
    { id: 'ConstructionCosts', label: 'Construction Costs'},
    { id: 'Valuations', label: 'Valuations' },
    { id: 'Cash-Flow-Model', label: 'Cash Flow - Model References' },
    { id: 'Tenant-Information', label: 'Tenant Information' },
    { id: 'Cashflow', label: 'Cash Flow' },
    { id: 'Cashflow-Living', label: 'Cash Flow Living' },
    { id: 'Cashflow-Retail', label: 'Cash Flow Retail' },
    { id: 'Revenue-and-Expense', label: 'Revenue and Expense' },
    { id: 'Assumptions', label: 'Assumptions' },
    { id: 'Lease-Expirations', label: 'Lease Expirations' },
    { id: 'Leasing-Assumptions', label: 'Leasing Assumptions' },
    { id: 'Contract-Month-Rent', label: 'Contract & Market Rent Information' },
    { id: 'Valuation-Summary', label: 'Valuation Summary' },    
    { id: 'Valuation-Comments', label: 'Valuation Comments' }
  ];

  calculateSectionErrors(): void {
    const sectionFieldsMap: { [key: string]: string[] } = {
      'Subject-Property': [
        'propertyTypeAndTenancy.propertyType',
        'propertyTypeAndTenancy.propertySubtype',
        'propertyTypeAndTenancy.tenancy',
        'externalReferenceId'
      ],
      'Location-Info': [
        'subjectPropertyLocation.propertyName',
        'subjectPropertyLocation.addressLine1',
        'subjectPropertyLocation.city',
        'subjectPropertyLocation.county',
        'subjectPropertyLocation.state',
        'subjectPropertyLocation.zipCode',
        'subjectPropertyLocation.country',
        'subjectPropertyLocation.streetLocation'
      ],
      'Parcel-Info': [
        'parcelInformation.assessorsParcelNumber'
      ],
      'Site-Info': [
        'siteInformation.primaryLandMeasure',
        'siteInformation.primaryLandValue',
        'siteInformation.primaryLandUnit',
        'siteInformation.secondaryLandMeasure',
        'siteInformation.secondaryLandValue',
        'siteInformation.secondaryLandUnit',
        'siteInformation.shape',
        'siteInformation.topography',
        'siteInformation.access',
        'siteInformation.visibility',
        'siteInformation.frontage',
        'siteInformation.utility',
        'siteInformation.siteImprovements',
        'siteInformation.groundLeases',
        'siteInformation.groundLeaseDescription',
        'siteInformation.primaryLandExcess',
        'siteInformation.secondaryLandExcess',
        'siteInformation.electric.paidBy',
        'siteInformation.gas.paidBy',
        'siteInformation.refuse.paidBy',
        'siteInformation.sewer.paidBy',
        'siteInformation.water.paidBy',
        'siteInformation.telephone.paidBy',
      ],
      'Ownership': [
        'ownership.soldInLastThreeYears',
        'ownership.saleDate',
        'ownership.salePrice',
        'ownership.listPrice',
        'ownership.contractPrice'
      ],      
      'Site-Conditions': [
        'siteConditions.soilConditions',
        'siteConditions.landUseRestrictions',
        'siteConditions.wetlands',
        'siteConditions.hazardousSubstances',
        'siteConditions.overallUtility',
        'siteConditions.summary'
      ],
      'Improvement-Info': [
        'improvementInformation.yearBuilt',
        'improvementInformation.yearRenovated',
        'improvementInformation.occupancy',
        'improvementInformation.vacancy',
        'improvementInformation.primaryImprovementMeasure',
        'improvementInformation.secondaryImprovementMeasure',
        'improvementInformation.tertiaryImprovementMeasure',
        'improvementInformation.primaryImprovementValue',
        'improvementInformation.primaryImprovementPriorValue',
        'improvementInformation.secondaryImprovementValue',
        'improvementInformation.secondaryImprovementPriorValue',
        'improvementInformation.tertiaryImprovementValue',
        'improvementInformation.tertiaryImprovementPriorValue',
        'improvementInformation.effectiveAge',
        'improvementInformation.economicLife'
      ],
      'Improvement-Info-Office': [
        'improvementInformationOffice.percentOfficeSpace'
      ],
      'Improvement-Info-Industrial': [
        'improvementInformationIndustrial.clearCeilingHeight',
        'improvementInformationIndustrial.numberOfDockHighDoors',
        'improvementInformationIndustrial.numberOfDriveInDoors',
        'improvementInformationIndustrial.percentOfficeSpace'
      ],
      'Improvement-Info-Living': [
        'improvementInformationLiving.numberOfUnits',
        'improvementInformationLiving.projectAmenities',
        'improvementInformationLiving.unitAmenities',
        'improvementInformationLiving.landOwnershipInterest'
      ],
      'Construction-Details': [
        'constructionDetails.basicConstruction',
        'constructionDetails.exteriorWalls',
        'constructionDetails.roofType',
        'constructionDetails.roofSurface'
      ],
      'Mechanical-Details': [
        'mechanicalDetails.hvac',
        'mechanicalDetails.fireProtection',
        'mechanicalDetails.security',
        'mechanicalDetails.numberofPassengerElevators',
        'mechanicalDetails.numberofFreightElevators'
      ],
      'Parking': [
        'parking.parkingTypeOne',
        'parking.parkingTypeOneNoOfSpaces',
        'parking.parkingTypeTwo',
        'parking.parkingTypeTwoNoOfSpaces',
        'parking.parkingTypeThree',
        'parking.parkingTypeThreeNoOfSpaces'
      ],
      'Taxes': [
        'taxes.currentTaxYear',
        'taxes.totalPropertyTaxes',
        'taxes.totalTaxRate',
        'taxes.equalizationRate',
        'taxes.assessmentRatio',
        'taxes.percentDiscountIfTaxBillPaidByDecember',
        'taxes.totalTaxExemptions',
        'taxes.totalAssessedValue',
        'taxes.improvementsAssessedValue',
        'taxes.landAssessedValue',
        'taxes.assessorsMarketValue'
      ],
      'Zoning': [
        'zoning.currentZoning',
        'zoning.isCurrentUsePermitted',
        'zoning.permittedUses',
        'zoning.prohibitedUses'
      ],
      'ConstructionCosts':[
        'constructionCosts.softCosts',
        'constructionCosts.furnitureFixturesandEquipment',
        'constructionCosts.siteImprovementCost',
        'constructionCosts.buildingImprovementCosts',
        'constructionCosts.totalEntrepreneurialProfit'
      ],
      'Valuations': [
        'valuations.dateOfReport',
        'valuations.dateOfValue',
        'valuations.dateOfInspection',
        'valuations.firrea',
        'valuations.isUSPAPCompliant',
        'valuations.clientOwnership'
      ],
      'Cash-Flow-Model': [
        'cashFlowModel.cashFlowModelName',
        'cashFlowModel.portfolioName',
        'cashFlowModel.scenarioName',
        'cashFlowModel.propertyName'
      ],
      'Cashflow': [
        'cashflow.year1NOIPSF',
        'cashflow.walt',
        'cashflow.vacancy',
        'cashflow.downtime',
        'cashflow.netOperatingIncome.year1',
        'cashflow.netOperatingIncome.year2',
        'cashflow.netOperatingIncome.year3',
        'cashflow.netOperatingIncome.year4',
        'cashflow.netOperatingIncome.year5',
        'cashflow.netOperatingIncome.year6',
        'cashflow.netOperatingIncome.year7',
        'cashflow.netOperatingIncome.year8',
        'cashflow.netOperatingIncome.year9',
        'cashflow.netOperatingIncome.year10',
        'cashflow.netOperatingIncome.year11',
        'cashflow.concessions',
        'cashflow.priorConcessions',
        'cashflow.collectionLoss',
        'cashflow.priorCollectionLoss',
        'cashflow.impliedOverallRate.year1',
        'cashflow.impliedOverallRate.year2',
        'cashflow.impliedOverallRate.year3',
        'cashflow.impliedOverallRate.year4',
        'cashflow.impliedOverallRate.year5',
        'cashflow.impliedOverallRate.year6',
        'cashflow.impliedOverallRate.year7',
        'cashflow.impliedOverallRate.year8',
        'cashflow.impliedOverallRate.year9',
        'cashflow.impliedOverallRate.year10',
        'cashflow.impliedOverallRate.year11',
        'cashflow.realEstateTaxGrowthRate',
        'cashflow.netCashFlowAmount'
      ],
      'Cashflow-Living': [
        'cashflowLiving.nonApartmentTotalPSF'
      ],
      'Tenant-Information': [
        'tenantInformation.largestTenant',
        'tenantInformation.largestTenantArea',
        'tenantInformation.largestTenantAreaPercent',
        'tenantInformation.leaseExpires'
      ],
      'Assumptions': [
        'assumptions.marketInflationYears1_5',
        'assumptions.priorMarketInflationYears1_5',
        'assumptions.expenseInflationYears1_5',
        'assumptions.priorExpenseInflationYears1_5'
      ],
      'Lease-Expirations': [
        'leaseExpirations.fiveYearCumulativeExpirationsPSF'
      ],
      'Leasing-Assumptions': [
        'leasingAssumptions.freeRent',
        'leasingAssumptions.leaseType',
        'leasingAssumptions.marketLeaseTerm',
        'leasingAssumptions.marketLeasingTenantImprovementsNewLeases',
        'leasingAssumptions.year1TenantImprovements',
        'leasingAssumptions.year1LeasingCommissions',
        'leasingAssumptions.marketLeasingCommissionsNewLeases',
        'leasingAssumptions.expenseReimbursement',
        'leasingAssumptions.renewalProbability'
      ],
      'Contract-Month-Rent': [
        'contractMonthRent.averageContractRentPSF',
        'contractMonthRent.priorAverageContractRentPSF',
        'contractMonthRent.annualContractRentTotal',
        'contractMonthRent.priorAnnualContractRentTotal',
        'contractMonthRent.averageMarketRentPSF',
        'contractMonthRent.priorAverageMarketRentPSF',
        'contractMonthRent.annualMarketRentTotal',
        'contractMonthRent.crmr',
        'contractMonthRent.marketOccupancyPercent'
      ],
      'Valuation-Summary': [
        'valuationSummary.asIsScenario.interestAppraised',
        'valuationSummary.asIsScenario.valueType',
        'valuationSummary.asIsScenario.valueCondition',
        'valuationSummary.asIsScenario.valueTiming',
        'valuationSummary.asIsScenario.dateOfValue',
        'valuationSummary.asIsScenario.capitalizationRate',
        'valuationSummary.asIsScenario.discountRate',
        'valuationSummary.asIsScenario.terminalCapitalizationRate',
        'valuationSummary.asIsScenario.internalRateOfReturn',
        'valuationSummary.asIsScenario.value',
        'valuationSummary.asIsScenario.landValue',
        'valuationSummary.asIsScenario.excessLandValue',
        'valuationSummary.asIsScenario.insurableReplacementCost',
        'valuationSummary.asIsScenario.costApproachIndicatedValue',
        'valuationSummary.asIsScenario.totalDepreciation',
        'valuationSummary.asIsScenario.salesComparisonApproachIndicatedValue',
        'valuationSummary.asIsScenario.incomeCapitalizationApproach',
        'valuationSummary.asIsScenario.directCapitalizationIndicatedValue',
        'valuationSummary.asIsScenario.finalValue',
        'valuationSummary.asIsScenario.priorFinalValue',
        'valuationSummary.asIsScenario.primaryValue',
        'valuationSummary.asIsScenario.priorTerminalCapitalizationRate',
        'valuationSummary.asIsScenario.priorInternalRateOfReturn',
        'valuationSummary.asIsScenario.priorCapitalizationRate',
        'valuationSummary.asIsScenario.exposurePeriod',
        'valuationSummary.asIsScenario.marketingPeriod',
        'valuationSummary.asIsScenario.yieldCapitalizationIndicatedValue',

        // added from ValidatorsMap (As Completed)
        'valuationSummary.uponCompletionScenario.landValue',
        'valuationSummary.uponCompletionScenario.excessLandValue',
        'valuationSummary.uponCompletionScenario.insurableReplacementCost',
        'valuationSummary.uponCompletionScenario.costApproachIndicatedValue',
        'valuationSummary.uponCompletionScenario.totalDepreciation',
        'valuationSummary.uponCompletionScenario.salesComparisonApproachIndicatedValue',
        'valuationSummary.uponCompletionScenario.incomeCapitalizationApproach',
        'valuationSummary.uponCompletionScenario.directCapitalizationIndicatedValue',
        'valuationSummary.uponCompletionScenario.finalValue',
        'valuationSummary.uponCompletionScenario.priorFinalValue',
        'valuationSummary.uponCompletionScenario.primaryValue',
        'valuationSummary.uponCompletionScenario.terminalCapitalizationRate',
        'valuationSummary.uponCompletionScenario.priorTerminalCapitalizationRate',
        'valuationSummary.uponCompletionScenario.internalRateOfReturn',
        'valuationSummary.uponCompletionScenario.priorInternalRateOfReturn',
        'valuationSummary.uponCompletionScenario.capitalizationRate',
        'valuationSummary.uponCompletionScenario.priorCapitalizationRate',
        'valuationSummary.uponCompletionScenario.exposurePeriod',
        'valuationSummary.uponCompletionScenario.marketingPeriod',
        'valuationSummary.uponCompletionScenario.yieldCapitalizationIndicatedValue',

        // added from ValidatorsMap (As Stabilized)
        'valuationSummary.uponStabilizationScenario.landValue',
        'valuationSummary.uponStabilizationScenario.excessLandValue',
        'valuationSummary.uponStabilizationScenario.insurableReplacementCost',
        'valuationSummary.uponStabilizationScenario.costApproachIndicatedValue',
        'valuationSummary.uponStabilizationScenario.totalDepreciation',
        'valuationSummary.uponStabilizationScenario.salesComparisonApproachIndicatedValue',
        'valuationSummary.uponStabilizationScenario.incomeCapitalizationApproach',
        'valuationSummary.uponStabilizationScenario.directCapitalizationIndicatedValue',
        'valuationSummary.uponStabilizationScenario.finalValue',
        'valuationSummary.uponStabilizationScenario.priorFinalValue',
        'valuationSummary.uponStabilizationScenario.primaryValue',
        'valuationSummary.uponStabilizationScenario.terminalCapitalizationRate',
        'valuationSummary.uponStabilizationScenario.priorTerminalCapitalizationRate',
        'valuationSummary.uponStabilizationScenario.internalRateOfReturn',
        'valuationSummary.uponStabilizationScenario.priorInternalRateOfReturn',
        'valuationSummary.uponStabilizationScenario.capitalizationRate',
        'valuationSummary.uponStabilizationScenario.priorCapitalizationRate',
        'valuationSummary.uponStabilizationScenario.exposurePeriod',
        'valuationSummary.uponStabilizationScenario.marketingPeriod',
        'valuationSummary.uponStabilizationScenario.yieldCapitalizationIndicatedValue'
      ],
      'Revenue-and-Expense': [
        'revenueAndExpense.yearOne.baseRentalRevenue',
        'revenueAndExpense.yearOne.totalOtherIncome',
        'revenueAndExpense.yearOne.potentialGrossRevenue',
        'revenueAndExpense.yearOne.vacancyandCollectionLoss',
        'revenueAndExpense.yearOne.effectiveGrossRevenue',
        'revenueAndExpense.yearOne.groundRent',
        'revenueAndExpense.yearOne.totalExpenses',
        'revenueAndExpense.yearOne.noiTotalAmount',
        'revenueAndExpense.yearOne.operatingExpenses',
        'revenueAndExpense.yearOne.generalnAdministrative',
        'revenueAndExpense.yearOne.insurance',
        'revenueAndExpense.yearOne.managementFees',
        'revenueAndExpense.yearOne.realEstateTaxes',
        'revenueAndExpense.yearOne.replacementReserves',
        'revenueAndExpense.stabilizedYear.baseRentalRevenue',
        'revenueAndExpense.stabilizedYear.totalOtherIncome',
        'revenueAndExpense.stabilizedYear.potentialGrossRevenue',
        'revenueAndExpense.stabilizedYear.vacancyandCollectionLoss',
        'revenueAndExpense.stabilizedYear.effectiveGrossRevenue',
        'revenueAndExpense.stabilizedYear.groundRent',
        'revenueAndExpense.stabilizedYear.totalExpenses',
        'revenueAndExpense.stabilizedYear.noiTotalAmount',
        'revenueAndExpense.stabilizedYear.operatingExpenses',
        'revenueAndExpense.stabilizedYear.generalnAdministrative',
        'revenueAndExpense.stabilizedYear.insurance',
        'revenueAndExpense.stabilizedYear.managementFees',
        'revenueAndExpense.stabilizedYear.realEstateTaxes',
        'revenueAndExpense.stabilizedYear.replacementReserves'
      ],
      'Valuation-Comments': [
        'valuationComments.appraisalValueComments'
      ]
    };

    // Create an object to hold detailed error logs per section.
    const sectionErrors: { [key: string]: { field: string; message: string }[] } = {};

    this.sectionErrorCounts = {};

    for (const sectionId in sectionFieldsMap) {
      const fieldPaths = sectionFieldsMap[sectionId];
      sectionErrors[sectionId] = [];
      this.sectionErrorCounts[sectionId] = fieldPaths.filter(path => {
        const result = this.getValidationStatus(path, this.rowDetails);
        if (!result.valid) {
          sectionErrors[sectionId].push({ field: path, message: result.message || '' });
        }
        return !result.valid;
      }).length;
    }
    console.log('Section errors detail:', sectionErrors);
    setTimeout(() =>
      this.dataLoaded = true, 5000
    );
  }


  scrollToFirstErrorSection(): void {
    const firstSectionId = Object.keys(this.sectionErrorCounts)
      .find(id => this.sectionErrorCounts[id] > 0);
    if (firstSectionId) {
      const el = document.getElementById(firstSectionId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  enhancedValuationRows = new Set([
    'Hold Period / Investment Horizon',
    'Capitalization Rate',
    'Terminal Capitalization Rate',
    'Internal Rate of Return / Discount Rate',
  ]);

  exposureAndMarketingTimesValuationRows = new Set([
    'Exposure Period',
    'Marketing Period',
  ]);

  valuationFormatTypes: Record<string, 'Currency' | 'Percentage'> = {
    'Capitalization Rate': 'Percentage',
    'Terminal Capitalization Rate': 'Percentage',
    'Internal Rate of Return / Discount Rate': 'Percentage',
    'Yield Capitalization Indicated Value': 'Currency',
    'Direct Capitalization Indicated Value': 'Currency',
    'Final Value': 'Currency',
    'Prior Final Value': 'Currency',
    'Primary Value': 'Currency',
    'CollectionLoss': 'Percentage',
    'MarketInflationYears': 'Percentage',
    'ExpenseInflationYears': 'Percentage',
    // Add more as needed
  };

  get valuationColumnDefs() {
    return [
      { headerName: 'Scenario', field: 'label', width: 200 },
      ...this.valuationScenarioDefs.map(def => ({
        headerName: def.headerName,
        field: def.field,
        width: 180
      }))
    ];
  }

  get pivotedValuationSummary(): any[] {
    if (!this.rowDetails?.valuationSummary || this.valuationScenarioDefs.length === 0) {
      return [];
    }

    const rows: any[] = [];

    const addRow = (label: string, key: string) => {
      rows.push(this.createValuationRow(label, key));
    };

    // Basic rows
    addRow('Interest Appraised', 'interestAppraised');
    addRow('Value Type', 'valueType');
    addRow('Value Condition', 'valueCondition');
    addRow('Value Timing', 'valueTiming');
    addRow('Date of Value / Effective Date', 'dateOfValue');
    addRow('Prior Date of Value', 'priorDateOfValue');
    addRow('Land Value', 'landValue');
    addRow('Excess Land Value', 'excessLandValue');
    addRow('Insurable Replacement Cost', 'insurableReplacementCost');
    addRow('Cost Approach Indicated Value', 'costApproachIndicatedValue');
    addRow('Sales Comparison Approach Indicated Value', 'salesComparisonApproachIndicatedValue');
    addRow('Income Capitalization Approach', 'incomeCapitalizationApproach');

    // Yield Cap / DCF row with its own sub-fields
    const yieldRow: any = { label: 'Yield Capitalization/Discounted Cash Flow Approach' };
    this.valuationScenarioDefs.forEach(def => {
      yieldRow[def.field] = this.valuationScenarios[def.index] || {};
    });
    rows.push(yieldRow);

    // --- Direct Capitalization group row ---
    const directRow: any = { label: 'Direct Capitalization' };
    this.valuationScenarioDefs.forEach(def => {
      directRow[def.field] = this.valuationScenarios[def.index] || {};
    });
    rows.push(directRow);

    addRow('Final Value Per Improvement Area Measure', 'finalValuePerImprovementAreaMeasure');

    return rows;
  }

  get revenueAndExpenseData(): any {
    if (this.rowDetails?.revenueAndExpense) {
      return this.rowDetails.revenueAndExpense;
    }

    // Fallback to legacy shape (pre-migration): first valuation scenario.
    return this.rowDetails?.valuationSummary?.scenarios?.[0] || {};
  }

  get revenueAndExpenseRows(): any[] {
    const source = this.revenueAndExpenseData;
    const add = (label: string, key: string) => ({
      label,
      yearOne: this.formatValue(source?.yearOne?.[key], label),
      stabilizedYear: this.formatValue(source?.stabilizedYear?.[key], label),
      yearOneValidationKey: `revenueAndExpense.yearOne.${key}`,
      stabilizedYearValidationKey: `revenueAndExpense.stabilizedYear.${key}`,
    });

    return [
      add('Base Rental Revenue', 'baseRentalRevenue'),
      add('Total Other Income', 'totalOtherIncome'),
      add('Potential Gross Revenue', 'potentialGrossRevenue'),
      add('Vacancy and Collection Loss', 'vacancyandCollectionLoss'),
      add('Effective Gross Revenue (Total Amount)', 'effectiveGrossRevenue'),
      add('Insurance', 'insurance'),
      add('General & Administrative', 'generalnAdministrative'),
      add('Management Fees', 'managementFees'),
      add('Replacement Reserves', 'replacementReserves'),
      add('Operating Expenses', 'operatingExpenses'),
      add('Real Estate Taxes', 'realEstateTaxes'),
      add('Ground Rent', 'groundRent'),      
      add('Total Expenses', 'totalExpenses'),
      add('NOI (Total Amount)', 'noiTotalAmount')
    ];
  }

  createValuationRow(label: string, key: string): any {
    const row: any = { label };

    this.valuationScenarioDefs.forEach(def => {
      const scenario = this.valuationScenarios[def.index];
      const current = scenario ? scenario[key] : '';

      row[def.field] = this.formatValue(current, label);

      if (this.enhancedValuationRows.has(label)) {
        const priorKey = `Prior${key}`;
        const prior = scenario ? scenario[priorKey] : '';
        row[`${def.field}Prior`] = this.getFormattedPrior(prior, label);
        row[`${def.field}Delta`] = this.getFormattedDelta(current, prior, label);
      }
    });

    return row;
  }

  private buildValuationSections(): void {
    if (!this.rowDetails?.valuationSummary || this.valuationScenarioDefs.length === 0) {
      this.valuationSections = [];
      return;
    }

    const base: any[] = [];
    const yieldRows: any[] = [];
    const directRows: any[] = [];
    const periodRows: any[] = [];

    const add = (target: any[], label: string, key: string) =>
      target.push(this.createValuationRow(label, key));

    // ----- Base Valuation rows (your original top block) -----
    add(base, 'Interest Appraised', 'interestAppraised');
    add(base, 'Value Type', 'valueType');
    add(base, 'Value Condition', 'valueCondition');
    add(base, 'Value Timing', 'valueTiming');
    add(base, 'Date of Value / Effective Date', 'dateOfValue');
    add(base, 'Prior Date of Value', 'priorDateOfValue');
    add(base, 'Land Value', 'landValue');
    add(base, 'Excess Land Value', 'excessLandValue');
    add(base, 'Insurable Replacement Cost', 'insurableReplacementCost');
    add(base, 'Cost Approach Indicated Value', 'costApproachIndicatedValue');
    add(base, 'Total Depreciation', 'totalDepreciation');
    add(base, 'Sales Comparison Approach Indicated Value', 'salesComparisonApproachIndicatedValue');
    add(base, 'Income Capitalization Approach', 'incomeCapitalizationApproach');

    // ----- Yield Capitalization / DCF section -----
    add(yieldRows, 'Hold Period / Investment Horizon', 'holdingPeriod');
    add(yieldRows, 'Terminal Capitalization Rate', 'terminalCapitalizationRate');
    add(yieldRows, 'Internal Rate of Return / Discount Rate', 'internalRateOfReturn');
    add(yieldRows, 'Yield Capitalization Indicated Value / DCF Indicated Value', 'yieldCapitalizationIndicatedValue');

    // ----- Direct Capitalization section -----
    add(directRows, 'Capitalization Rate', 'capitalizationRate');
    add(directRows, 'Direct Capitalization Indicated Value', 'directCapitalizationIndicatedValue');
    add(directRows, 'Final Value', 'finalValue');
    add(directRows, 'Prior Final Value', 'priorFinalValue');
    add(directRows, 'Primary Value', 'primaryValue');    
    add(periodRows, 'Exposure Period', 'exposurePeriod');
    add(periodRows, 'Marketing Period', 'marketingPeriod');

    this.valuationSections = [
      { id: 'base', title: null, rows: base },
      { id: 'yield', title: 'Yield Capitalization/Discounted Cash Flow Approach', rows: yieldRows },
      { id: 'direct', title: 'Direct Capitalization', rows: directRows },
      { id: 'period', title: 'Exposure and Marketing Times', rows: periodRows }
    ];
  }

  capitalizeFirstLetter(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  toNumber(value: any | null | undefined): number {
    if (typeof value === 'string' && value !== '-' && value !== '.') {
      return Number(value.trim().replace(/[^0-9.-]+/g, ''));
    } else {
      return 0;
    }
  }

  calculateDelta(current: any, prior: any, fieldType: string): number {
    switch (fieldType) {
      case 'Vacancy':
      case 'Occupancy':
      case 'CollectionLoss':
      case 'Concessions':
      case 'MarketInflationYears':
      case 'ExpenseInflationYears':
      case 'ImprovementArea':
        return this.calculateDeltaBasedOnPrior(current, prior);
      case 'ORR':
      case 'IRRDR':
      case 'TCR':
        return this.calculateSimpleDelta(current, prior);
      default:
        return this.calculateSimpleDelta(current, prior);
    }
  }

  calculateSimpleDelta(current: any, prior: any): number {
    const cur = this.toNumber(current);
    const prv = this.toNumber(prior);
    return (cur - prv);
  }

  calculateDeltaBasedOnPrior(current: any, prior: any): number {
    const cur = this.toNumber(current);
    const prv = this.toNumber(prior);

    if (cur === null || isNaN(cur) || prv === null || isNaN(prv) || prv === 0) {
      return 0;
    }

    return ((cur - prv) / prv) * 100;
  }


  formatValue(rawValue: any, fieldType: string): string {
    // 🍃 if it’s null, undefined, or the empty string, just return an empty string
    if (rawValue === null || rawValue === undefined || rawValue === '') {
      return '';
    }

    const type = this.valuationFormatTypes?.[fieldType];

    if (fieldType === 'Currency') {
      const num = Number(rawValue);
      if (isNaN(num)) return rawValue.toString();
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num);
    }

    if (type === 'Percentage') {
      const num = Number(rawValue);
      if (isNaN(num)) return rawValue.toString();
      return `${num.toFixed(2)}%`;
    }

    if (fieldType === 'FloodMapDate' || fieldType === 'DateOfReport' || fieldType === 'DateOfValue' || fieldType === 'DateOfInspection') {
      const d = new Date(rawValue);
      if (!isNaN(d.getTime())) {
        return this.datePipe.transform(d, 'MM/dd/yyyy') || '';
      } else {
        return rawValue.toString();
      }
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const yyyy = d.getFullYear();
      return `${mm}/${dd}/${yyyy}`;
    }

    if (fieldType === 'LandArea' || fieldType === 'ImprovementArea') {
      const num = Number(rawValue);
      if (isNaN(num)) {
        return rawValue.toString();
      }
      return num.toLocaleString('en-US');
    }

    if (fieldType === 'Walt') {
      const num = Number(rawValue);
      if (isNaN(num)) {
        return rawValue.toString();
      }
      // truncate to two decimals
      const truncated = Math.trunc(num * 100) / 100;
      // strip trailing zeros like “.00” or “.0”
      let s = truncated.toString();
      if (s.includes('.')) {
        s = s.replace(/\.?0+$/, '');
      }
      return s;
    }

    if (fieldType === 'Hold Period / Investment Horizon') {
      return rawValue.toString();
    }

    // fallback: try to coerce to number
    let value = Number(rawValue);
    if (isNaN(value)) {
      return rawValue.toString();
    }

    switch (fieldType) {
      case 'Vacancy':
      case 'Occupancy':
      case 'Concessions':
        return `${value.toFixed(2)}%`;

      case 'ORR':
      case 'IRRDR':
      case 'TCR':
        value = Math.round(value * 400) / 4; // multiply by 100 then round to .25
        break;
      case 'Average Contract Rent':
      case 'Average Contract Rent Total':
      case 'Average Market Rent':
      case 'Average Market Rent Total':
        value = Number(value.toFixed(2));
        break;

      default:
        value = Math.round(value * 4) / 4;
        break;
    }

    // strip any trailing “.0” or “.00”
    let strValue = value.toString();
    if (strValue.includes('.')) {
      strValue = strValue.replace(/\.?0+$/, '');
    }
    return strValue;
  }


  getValuationSummaryFormattedValue(row: any, col: any): string {
    const val = row[col.field];
    return row.label === 'Holding Period' && (col.field == 'asIsScenario' || col.field == 'uponCompletionScenario' || col.field == 'uponStabilizationScenario')
      ? `${val} Years`
      : val;
  }

  shouldShowPrior(current: any, prior: any): boolean {
    return prior !== '' && prior !== null && prior !== undefined && prior !== 0 && prior !== 0.0 && prior !== 0.00;
  }

  shouldShowDelta(current: any, prior: any): boolean {
    const isValid = (value: any) =>
      value !== '-' && value !== '' && value !== null && value !== undefined && value !== 0 && value !== 0.0 && value !== 0.00;

    return isValid(current) && isValid(prior);
  }



  getFormattedDelta(current: any, prior: any, type: string = ''): string {
    if (this.shouldShowDelta(current, prior) && type === '') {
      return '-';
    }
    if (type === 'ImprovementArea') {
      return this.shouldShowDelta(current, prior) ? this.formatValue(this.calculateDelta(current, prior, type), type) + '%' : '-';
    }
    return this.shouldShowDelta(current, prior) ? this.formatValue(this.calculateDelta(current, prior, type), type) : '-';
  }

  getFormattedPrior(prior: any, type: string = ''): string {
    if (this.shouldShowPrior(null, prior) && type === '')
      return '-';
    return this.shouldShowPrior(null, prior) ? this.formatValue(prior, type) : '-';
  }

  getyear1To5NOI() {
    const avg = this.calculateAvg(
      this.rowDetails?.cashflow?.impliedOverallRate?.['year1'],
      this.rowDetails?.cashflow?.impliedOverallRate?.['year2'],
      this.rowDetails?.cashflow?.impliedOverallRate?.['year3'],
      this.rowDetails?.cashflow?.impliedOverallRate?.['year4'],
      this.rowDetails?.cashflow?.impliedOverallRate?.['year5']
    ).toFixed(2);

    return avg.endsWith('%') ? avg : `${avg}%`;
  }

  getyear6To10NOI() {
    const avg = this.calculateAvg(
      this.rowDetails?.cashflow?.impliedOverallRate?.['year6'],
      this.rowDetails?.cashflow?.impliedOverallRate?.['year7'],
      this.rowDetails?.cashflow?.impliedOverallRate?.['year8'],
      this.rowDetails?.cashflow?.impliedOverallRate?.['year9'],
      this.rowDetails?.cashflow?.impliedOverallRate?.['year10']
    ).toFixed(2);

    return avg.endsWith('%') ? avg : `${avg}%`;
  }


  calculateAvg = (index1: any, index2: any, index3: any, index4: any, index5: any): number => {
    const values = [index1, index2, index3, index4, index5].map(v =>
      Number(String(v).replace(/[^0-9.-]+/g, '')) || 0
    );
    const sum = values.reduce((acc, x) => acc + x, 0);
    const avg = sum / values.length;
    return avg;
  };

  getDollarFormatted(value: any): string {
    if (value == null || value === '' || value === '-') return ''; // handle null/empty
    const strValue = value.toString().trim();
    return strValue.startsWith('$') ? strValue : `$${strValue}`;
  }

  getPercentageFormatted(value: any): string {
    if (value == null || value === '') return ''; // handle null/empty
    const strValue = value.toString().trim().replace(/%+$/, ''); // remove existing % for consistent formatting
    return isNaN(strValue) ? strValue : `${strValue}%`;
  }

  isNumericOrCurrencyDisplay(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    const str = String(value).trim();
    if (!str) {
      return false;
    }

    // Supports: 123, 1,234.56, $1,234, ($282), -123.45, 12.50%
    const numericLike = /^\(?\s*-?\$?\s*\d[\d,]*(?:\.\d+)?\s*%?\s*\)?$/;
    return numericLike.test(str);
  }

  getKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  isValSummaryNonLabelCol(i: number): boolean {
    return i > 0;
  }

  // Maps Valuation Summary row label -> validator field key
  private valuationRowKeyMap: Record<string, string> = {
    'Interest Appraised': 'interestAppraised',
    'Value Type': 'valueType',
    'Value Condition': 'valueCondition',
    'Value Timing': 'valueTiming',
    'Date of Value / Effective Date': 'dateOfValue',
    'Prior Date of Value': 'priorDateOfValue',
    'Land Value': 'landValue',
    'Excess Land Value': 'excessLandValue',
    'Insurable Replacement Cost': 'insurableReplacementCost',
    'Cost Approach Indicated Value': 'costApproachIndicatedValue',
    'Total Depreciation': 'totalDepreciation',
    'Sales Comparison Approach Indicated Value': 'salesComparisonApproachIndicatedValue',
    'Income Capitalization Approach': 'incomeCapitalizationApproach',
    'Hold Period / Investment Horizon': 'holdingPeriod',
    'Terminal Capitalization Rate': 'terminalCapitalizationRate',
    'Internal Rate of Return / Discount Rate': 'internalRateOfReturn',
    'Yield Capitalization Indicated Value / DCF Indicated Value': 'yieldCapitalizationIndicatedValue',
    'Capitalization Rate': 'capitalizationRate',
    'Direct Capitalization Indicated Value': 'directCapitalizationIndicatedValue',
    'Final Value': 'finalValue',
    'Prior Final Value': 'priorFinalValue',
    'Primary Value': 'primaryValue',
    'Exposure Period': 'exposurePeriod',
    'Marketing Period': 'marketingPeriod',
    'Final Value Per Improvement Area Measure': 'finalValuePerImprovementAreaMeasure'
  };

  private getScenarioValidationKey(colField: string): string | null {
    const def = this.valuationScenarioDefs.find(d => d.field === colField);
    if (!def) return null;

    const scenario = this.valuationScenarios?.[def.index] ?? {};
    const scenarioName = String(
      scenario?.scenario ?? scenario?.Scenario ?? scenario?.valueTiming ?? scenario?.ValueTiming ?? ''
    ).toLowerCase();

    if (scenarioName.includes('as is')) return 'asIsScenario';
    if (scenarioName.includes('completion')) return 'uponCompletionScenario';
    if (scenarioName.includes('stabil')) return 'uponStabilizationScenario';

    // Deterministic fallback for data sets that omit scenario labels.
    const byIndex = ['asIsScenario', 'uponCompletionScenario', 'uponStabilizationScenario'];
    return byIndex[def.index] ?? null;
  }

  // Builds the validator path for a valuation-summary cell
  private validationKeyForValuationCell(row: any, col: any): string | null {
    if (!row || !col || !col.field || col.field === 'label') return null;

    const rowKey = this.valuationRowKeyMap[row.label];
    if (!rowKey) return null;

    const scenarioKey = this.getScenarioValidationKey(col.field);
    if (!scenarioKey) return null;

    return `valuationSummary.${scenarioKey}.${rowKey}`;
  }

  isValSummaryInvalid(row: any, col: any): boolean {
    const key = this.validationKeyForValuationCell(row, col);
    if (!key) return false;

    const status = this.getValidationStatus(key, this.rowDetails);
    return !status?.valid;
  }

  getValSummaryMessage(row: any, col: any): string | null {
    const key = this.validationKeyForValuationCell(row, col);
    if (!key) return null;

    return this.getValidationStatus(key, this.rowDetails).message || null;
  }

  // If you maintain side badges, include Valuation-Summary counts:
  private recomputeSectionErrorCounts(): void {

    const vsCount =
      (this.pivotedValuationSummary ?? []).reduce((acc: number, row: any) => {
        return (
          acc +
          (this.valuationColumnDefs ?? []).reduce((acc2: number, col: any, idx: number) => {
            if (idx === 0) return acc2; // skip the label column
            return acc2 + (this.isValSummaryInvalid(row, col) ? 1 : 0);
          }, 0)
        );
      }, 0);

    this.sectionErrorCounts['Valuation-Summary'] = vsCount;
  }

  groupFieldConfigs: Record<string, GroupFieldConfig[]> = {
    'Yield Capitalization/Discounted Cash Flow Approach': [
      {
        label: 'Hold Period / Investment Horizon',
        valueKey: 'holdingPeriod',
        priorKey: 'priorHoldingPeriod',
        typeKey: 'Hold Period / Investment Horizon'
      },
      {
        label: 'Terminal Capitalization Rate',
        valueKey: 'terminalCapitalizationRate',
        priorKey: 'priorTerminalCapitalizationRate',
        typeKey: 'Terminal Capitalization Rate'
      },
      {
        label: 'Internal Rate of Return / Discount Rate',
        valueKey: 'internalRateOfReturn',
        priorKey: 'priorInternalRateOfReturn',
        typeKey: 'Internal Rate of Return / Discount Rate'
      },
      {
        label: 'Yield Capitalization Indicated Value / DCF Indicated Value',
        valueKey: 'yieldCapitalizationIndicatedValue',
        // if you ever add PriorYieldCapitalizationIndicatedValue, set priorKey
        typeKey: 'Yield Capitalization Indicated Value'
      }
    ],

    'Direct Capitalization': [
      {
        label: 'Capitalization Rate',
        valueKey: 'capitalizationRate',
        priorKey: 'priorCapitalizationRate',
        typeKey: 'Capitalization Rate'
      },
      {
        label: 'Direct Capitalization Indicated Value',
        valueKey: 'directCapitalizationIndicatedValue',
        typeKey: 'Direct Capitalization Indicated Value'
      },
      {
        label: 'Final Value',
        valueKey: 'finalValue',
        priorKey: 'priorFinalValue',
        typeKey: 'Final Value'
      },
      {
        label: 'Primary Value',
        valueKey: 'primaryValue',
        typeKey: 'Primary Value'
      }
    ],

    'Revenue and Expense': [
      {
        label: 'Effective Gross Revenue (Total Amount)',
        valueKey: 'effectiveGrossRevenue',
        typeKey: 'Effective Gross Revenue (Total Amount)'
      },
      {
        label: 'Total Expenses',
        valueKey: 'totalExpenses',
        typeKey: 'Total Expenses'
      },
      {
        label: 'NOI (Total Amount)',
        valueKey: 'noiTotalAmount',
        typeKey: 'NOI (Total Amount)'
      },
      {
        label: 'Net Cash Flow Amount',
        valueKey: 'netCashFlowAmount',
        typeKey: 'Net Cash Flow Amount'
      },
      {
        label: 'Operating Expenses',
        valueKey: 'operatingExpenses',
        typeKey: 'Operating Expenses'
      },
      {
        label: 'General & Administrative',
        valueKey: 'generalnAdministrative',
        typeKey: 'General & Administrative'
      },
      {
        label: 'Insurance',
        valueKey: 'insurance',
        typeKey: 'Insurance'
      },
      {
        label: 'Management Fees',
        valueKey: 'managementFees',
        typeKey: 'Management Fees'
      },
      {
        label: 'Real Estate Taxes',
        valueKey: 'realEstateTaxes',
        typeKey: 'Real Estate Taxes'
      },
      {
        label: 'Replacement Reserves',
        valueKey: 'replacementReserves',
        typeKey: 'Replacement Reserves'
      },
      {
        label: 'Exposure Period',
        valueKey: 'exposurePeriod',
        typeKey: 'Exposure Period'
      },
      {
        label: 'Marketing Period',
        valueKey: 'marketingPeriod',
        typeKey: 'Marketing Period'
      }
    ]
  };

  isGroupedRow(label: string): boolean {
    return !!this.groupFieldConfigs[label];
  }

  getGroupedItems(row: any, scenarioField: string): GroupItem[] {
    const scenario: any = row?.[scenarioField] || {};
    const configs = this.groupFieldConfigs[row.label] || [];
    const items: GroupItem[] = [];

    for (const cfg of configs) {
      const curRaw = scenario[cfg.valueKey];
      const priorRaw = cfg.priorKey ? scenario[cfg.priorKey] : undefined;

      const hasAny =
        (curRaw !== null && curRaw !== undefined && curRaw !== '') ||
        (priorRaw !== null && priorRaw !== undefined && priorRaw !== '');

      if (!hasAny) continue;

      const current = this.formatValue(curRaw, cfg.typeKey);
      const prior = this.getFormattedPrior(priorRaw, cfg.typeKey);
      const delta = this.getFormattedDelta(curRaw, priorRaw, cfg.typeKey);

      items.push({ label: cfg.label, current, prior, delta });
    }

    return items;
  }
}
